import { withAsyncPaginate } from "react-select-async-paginate";
import { CreatableSelect } from "shared/components";

export const CreatableAsyncSelect = withAsyncPaginate(CreatableSelect as any);
